<template>
  <div
    class="form-field-input-wrapper"
    :class="{
      'form-field-input-wrapper--reverse': reverse,
    }"
  >
    <div
      v-if="$slots.side && reverse"
      class="ffiw-side"
    >
      <slot name="side" />
    </div>
    <div
      class="ffiw-input"
      :class="{ 'ffiw-input--no-flex': noFlexInput }"
    >
      <slot />
    </div>
    <div
      v-if="$slots.side && !reverse"
      class="ffiw-side"
      :class="{
        'ffiw-side--less-margin': lessSideMargin,
        'ffiw-side--no-flex': noFlexSide,
        'ffiw-side--no-margin': noSideMargin,
      }"
    >
      <slot name="side" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reverse: {
      type: Boolean,
    },
    noFlexInput: {
      type: Boolean,
    },
    noFlexSide: {
      type: Boolean,
    },
    lessSideMargin: {
      type: Boolean,
    },
    noSideMargin: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.form-field-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  .ffiw-input {
    flex: 1 0;

    &--no-flex {
      flex: none;
    }
  }

  .ffiw-side {
    flex: 0 0 16px;
    margin: 0 0 0 $pad;
    align-self: flex-start;

    &--no-flex {
      flex: none;
    }

    &--less-margin {
      margin: 0 0 0 math.div($pad, 2.5);
    }

    &--no-margin {
      margin: 0;
    }

    :deep(.button--plain) {
      right: math.div($pad, 2);
    }
  }

  &.form-field-info-wrapper--reverse {
    .ffiw-side {
      margin-left: 0;
      margin-right: $pad;
    }
  }
}
</style>
